import React from 'react';

/** Shared line renderer — used by editor preview, export framing, and matches Chromium export HTML. */
export function CaptionLines({ lines, tokens, highlightColor, animation, keyPrefix = 'cap' }) {
  if (Array.isArray(tokens) && tokens.length) {
    const activeColor = highlightColor || '#d4ff00';
    return (
      <span
        className="block w-full"
        style={{ wordBreak: 'break-word', overflowWrap: 'break-word', fontWeight: 800 }}
      >
        {tokens.map((token, index) => (
          <span key={`${keyPrefix}-tok-${index}`}>
            {index > 0 ? ' ' : ''}
            <span
              style={token.active ? {
                color: 'inherit',
                background: activeColor,
                borderRadius: 2,
                padding: '0.02em 0.14em',
                boxDecorationBreak: 'clone',
                WebkitBoxDecorationBreak: 'clone',
              } : { color: 'inherit' }}
            >
              {String(token.word || '').toLocaleUpperCase()}
            </span>
          </span>
        ))}
      </span>
    );
  }
  return (lines || []).map((line, idx) => {
    const text = String(line || '');
    if (animation === 'wave' && text) {
      return (
        <span
          // eslint-disable-next-line react/no-array-index-key
          key={`${keyPrefix}-ln-${idx}`}
          className="block w-full"
          style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}
        >
          {[...text].map((ch, ci) => (
            <span
              // eslint-disable-next-line react/no-array-index-key
              key={`${keyPrefix}-ln-${idx}-ch-${ci}`}
              className="subtitle-char-wave inline-block"
              style={{ animationDelay: `${ci * 0.07}s` }}
            >
              {ch === ' ' ? '\u00a0' : ch}
            </span>
          ))}
        </span>
      );
    }
    return (
      <span
        // eslint-disable-next-line react/no-array-index-key
        key={`${keyPrefix}-ln-${idx}`}
        className="block w-full"
        style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}
      >
        {text}
      </span>
    );
  });
}
